import { WSCard, WSInfoBox, WSList } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { queriesPayers } from "@query";
import { DataItem } from "../../../../shared/components/DataItem";
import { selectorMethodValueFromPaymentMethodRef } from "../../../../shared/selectors/selectorMethodValueFromPaymentMethodRef";
import { usePayrollFundingMethodsManagedByOrganization } from "../../../../userFeatures/usePayrollFundingMethodsManagedByOrganization";
import { useUserOrganizationName } from "../../../../userFeatures/useUserOrganizationName";
import { LabelMethod } from "../LabelMethod";
import { PATH_SETTINGS_PAYROLL_MANAGE_FUNDING_METHOD } from "../../paths";

export const DefaultFundingMethod: React.FC = () => {
  const queryPayerSettings = queriesPayers.getCurrentPayerSettings.useQuery();
  const history = useHistory();
  const isManagedByOrg = usePayrollFundingMethodsManagedByOrganization();
  const organizationName = useUserOrganizationName();

  const fundingMethod = selectorMethodValueFromPaymentMethodRef(
    queryPayerSettings.data?.payrollSettings?.defaultFundingSource
  );

  return (
    <WSCard
      divider={!isManagedByOrg}
      header={{
        label: {
          text: "Payroll funding method",
          helperText: "Default method to fund contractor payroll"
        },
        value: {
          pill: {
            theme: "neutral",
            text: "Default"
          }
        }
      }}
      actions={
        isManagedByOrg
          ? undefined
          : {
              alignment: "left",
              buttons: [
                {
                  kind: "Link",
                  label: "Manage payroll funding method",
                  onClick: () => {
                    history.push(PATH_SETTINGS_PAYROLL_MANAGE_FUNDING_METHOD);
                  }
                }
              ]
            }
      }
    >
      <WSList gap="XL">
        {fundingMethod ? (
          <LabelMethod type={fundingMethod.type} id={fundingMethod.id} />
        ) : (
          <DataItem />
        )}

        {isManagedByOrg && (
          <WSInfoBox>
            Payroll funding method is managed by {organizationName} - contact{" "}
            {organizationName} support.
          </WSInfoBox>
        )}
      </WSList>
    </WSCard>
  );
};
